import { render, staticRenderFns } from "./Saldocaixa.vue?vue&type=template&id=5e97726a&"
import script from "./Saldocaixa.vue?vue&type=script&lang=js&"
export * from "./Saldocaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports